import api from "./axios";

export const fetchSavedSearches = async ({ queryKey }) => {
  const [_key, { page, limit, search_mode }] = queryKey;
  const response = await api.get("/users/profile/saved-searches/", {
    params: { page, limit, search_mode },
  });
  return response.data;
};

export const saveSearch = async ({
  search_type,
  search_mode,
  filter_data,
  keyword,
}) => {
  const response = await api.post("/users/profile/save-search/", {
    search_type,
    filter_data,
    keyword,
    search_mode,
  });
  return response.data;
};

export const searchProfiles = async ({
  page,
  limit,
  filter_data,
  saved_search_id,
  keyword,
}) => {
  const response = await api.get("/users/profile/search/", {
    params: {
      page,
      limit,
      filter_data,
      saved_search_id,
      keyword,
    },
  });

  return response.data.data;
};

export const removeSavedSearch = async ({ id, remove_all = false }) => {
  const response = await api.post("/users/profile/saved-search/remove", {
    id,
    remove_all,
  });
  return response.data.data;
};
